module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/rack-server/rackback2.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/rack-server/rackback2.png
// module id = 607
// module chunks = 0